import {LayoutBreakpointsConfig} from '../../components-shared/LayoutSizeProvider/types'

export const LAYOUT_BREAKPOINTS_START: LayoutBreakpointsConfig = {
  XS: 320,
  S: 750,
  M: 980,
  L: 1120,
}
